import Typography from "@mui/material/Typography";
import { Box } from "@mui/material";
import styled from "styled-components";
import Colors from "@constants/Colors";

export const StyledRootBox = styled(Box)`
  display: flex !important;
  flex-direction: column !important;
  padding: 16px !important;
  gap: 8px !important;
  background: ${Colors.white} !important;
  border: 1px solid ${Colors.neutral_gray_300} !important;
  border-radius: 12px !important;
  min-height: inherit !important;
`;

export const StyledSalesBox = styled(Box)`
  display: flex !important;
  flex-direction: column !important;
  gap: 8px !important;
  padding: 0px !important;
  width: 50%;
`;

export const StyledSalesRow = styled(Box)`
  display: flex !important;
  justify-content: space-between !important;
  padding: 8px 0px !important;
  border-bottom: 1px solid ${Colors.neutral_gray_300};
`;

export const StyledTitle = styled(Typography)<{ color: string }>`
  font-family: "Ringside Regular-Bold" !important;
  font-weight: 400 !important;
  font-size: 16px !important;
  line-height: 24px !important;
  display: flex !important;
  align-items: center !important;
  color: ${({ color }: { color: string }) => color};
`;

export const StyledTypography = styled(Typography)`
  font-family: "Ringside Regular-Book" !important;
  font-weight: 400 !important;
  font-size: 16px !important;
  line-height: 24px !important;
  display: flex !important;
  align-items: center !important;
  color: ${Colors.neutral_gray_500};
`;

export const StyledChartHeading = styled(Typography)`
  font-family: "Ringside Regular-Bold" !important;
  font-weight: 400 !important;
  font-size: 16px !important;
  line-height: 24px !important;
  display: flex !important;
  align-items: center !important;
  color: ${Colors.primary};
`;

export const StyledBox = styled(Box)`
  display: flex !important;
  flex-direction: column !important;
  gap: 8px !important;
  border-bottom: 1px solid ${Colors.neutral_gray_300} !important;
  font-family: "Ringside Regular-Book" !important;
  font-weight: 325 !important;
  font-size: 14px !important;
  line-height: 20px !important;
  min-height: 214px !important;
`;

export const StyledValue = styled(Typography)`
  font-family: "Ringside Regular-Bold" !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  line-height: 20px !important;
  display: flex !important;
  align-items: center !important;
  color: ${Colors.black};
`;
